const fixedbtn = document.querySelector(".cart__checkout.fixed_btn");
const checkoutbtn = document.querySelector(".cart__checkout");
// Interception Handler
const callback = (entries, observer) => {
  for (const entry of entries) {
    // Load more articles;
    if (entry.isIntersecting) {
      fixedbtn.classList.remove("show_bottom");
    }else{
     fixedbtn.classList.add("show_bottom");
    }
  }
}

// Observe the end of the list
const observer = new IntersectionObserver(callback, {
  threshold: 0,
});
observer.observe(checkoutbtn);

if (typeof(document.querySelector('#input_32077653180488')) != 'undefined' && document.querySelector('#input_32077653180488') != null)
{
  var _scrollDiv = document.querySelector('#input_32077653180488');
  var scrollDiv = document.querySelector('#input_32077653180488').offsetTop;
  fixedbtn.addEventListener("click", function(){

    document.querySelector('#input_32077653180488').scrollIntoView({
      top: scrollDiv,
      behavior: 'smooth'
    });
  });
}


document.querySelector('.popup_order_error').addEventListener("click", function() {
  document.querySelector('.popup_order_error').style.display = 'none';
});
document.querySelector('.popup_order_error_35').addEventListener("click", function() {
  document.querySelector('.popup_order_error_35').style.display = 'none';
});

let input = document.querySelectorAll(".qty .input_qty");


input.forEach(i => i.addEventListener("click", e => {    
  i.focus();
  i.select();
}))

let width = screen.width;
const cart_mobile =  document.querySelector('.cart__mobile');
const cart_desk =  document.querySelector('.cart__desk');
if(width > 678) {
  cart_mobile.remove();
}else{
  cart_desk.remove();
}
const gallery_zoom = document.querySelectorAll('.zoom__images .grid__image-ratio img');
gallery_zoom.forEach(i => i.addEventListener("click", e => {    
  const popup_image = i.closest('.grid-product__content').querySelector('.mobile__Gallery');
  popup_image.classList.add('current__popup');
}))
const gallery_zoom__close = document.querySelectorAll('.zoom__images .close__popup');
gallery_zoom__close.forEach(i => i.addEventListener("click", e => {    
  const popup_image = i.closest('.mobile__Gallery');
  popup_image.classList.remove('current__popup');
}))

const gallery = document.querySelectorAll('.zoom__images .mobile__Gallery');
gallery.forEach(i => i.addEventListener("click", e => {    
    var container = document.querySelector('.mobile__Gallery');
   if(!container.contains(e.target)){
      const popup_image = i;
      popup_image.classList.remove('current__popup');
    }
  
    var _container = document.querySelector('.current__popup');
  console.log(_container);
   if(_container.contains(e.target)){
      const popup_image = i;
      popup_image.classList.remove('current__popup');
    }
  
}))

document.querySelector('#checkout').addEventListener("click", e => {  
  e.preventDefault();
  let num = parseInt(document.querySelector('.cart-link__bubble-num').innerText);
   if (num < 35 ){
       document.querySelector('.popup_order_error_35').style.display = 'block';
  return false;
   }else {
     window.location.href = "https://doanchaoc.com/checkout";
   }
})
  
